import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "What's included in the VR headset rental?",
    a: "Every VR rental includes the Meta Quest 3 headset, two controllers, a charging cable, and a carrying case. We also preload popular games and apps so you can start playing immediately.",
  },
  {
    q: "How does VR headset delivery and return work in Pune and Mumbai?",
    a: "We deliver the VR headset to your doorstep in Pune and Mumbai on the start date. When your rental ends, we schedule a free pickup at your convenience. No need to visit a store or ship anything.",
  },
  {
    q: "What if I damage the rented VR headset?",
    a: "All VR rentals include basic damage protection at no extra cost. Normal wear and tear is fully covered. Intentional damage or loss may incur a replacement fee.",
  },
  {
    q: "Can I extend my VR headset rental?",
    a: "Absolutely. Contact us before your VR rental ends and we'll extend it seamlessly. You'll only pay the prorated difference.",
  },
  {
    q: "How much does it cost to rent a VR headset in Pune?",
    a: "VR headset rental in Pune starts at just ₹799 for 1 day. A 3-day VR rental costs ₹1,499 and a 7-day rental costs ₹2,499. All rentals include free delivery, preloaded games, and damage protection.",
  },
  {
    q: "Do you deliver VR headsets in Mumbai?",
    a: "Yes! We deliver Meta Quest 3 and Oculus Quest 2 VR headsets across Mumbai, Navi Mumbai, and Thane. 3-day and 7-day VR rental plans are available for Mumbai delivery.",
  },
  {
    q: "How do payments work for VR rental?",
    a: "We use Razorpay for secure payments. You can pay via UPI, credit/debit card, net banking, or popular wallets. Your payment is fully encrypted and protected.",
  },
  {
    q: "Do I need a Facebook/Meta account to use the rented VR headset?",
    a: "No. We provide a guest account preloaded on the device so you can start playing right away. You're welcome to log in with your own Meta account if you prefer.",
  },
];

const FAQSection = () => {
  return (
    <section id="faq" className="py-24 md:py-36 px-6">
      <div className="max-w-narrative mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="font-heading text-3xl md:text-5xl font-bold text-foreground text-center mb-16"
        >
          VR Rental FAQs — Pune & Mumbai
        </motion.h2>

        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.08 }}
            >
              <AccordionItem
                value={`faq-${i}`}
                className="border border-border rounded-lg px-6 bg-card"
              >
                <AccordionTrigger className="font-heading text-base font-medium text-foreground hover:text-primary hover:no-underline py-5">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="font-body text-sm text-muted-foreground leading-relaxed pb-5">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            </motion.div>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
